import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

// Reusable auth guard function
export const authGuard = (url: any) => {
  const router = inject(Router);
  const isLoggedIn = inject(AuthService).isLoggedIn();
  if (!isLoggedIn) {
    return router.createUrlTree(['/auth']);
  }

  return true;
};
